import { lazyForPaint } from 'react-loosely-lazy';
import { withAsync } from 'view/common/with-async';

export default withAsync({
    loader: lazyForPaint(
        () => import(/* webpackChunkName: "edit-page-layout-with-popup" */ './edit-page-layout-with-popup')
    ),
});
